export default "__VITE_PUBLIC_ASSET__0436f5e3__"